import {WeatherStationFromDetail} from '../api/types';
import useTimeDifference from './useTimeDifference';

const useStationLastUpdateFormat = (station: WeatherStationFromDetail) => {
  return useTimeDifference(station?.last_measure_at);
};

export default useStationLastUpdateFormat;
